import { GetterTree } from "vuex";
import { ScoreState } from "../types";
import { IRootState, IRootGetters } from "../../types";
import {
  UnitAndCalories,
  emptyUnitAndCalories,
  initialDrinkingDay,
  DrinkingDay,
  DrinkerType,
  initialDrinkerType
} from "@dcc/types/drinkingDay";
import {
  getWeeklyUnitsAndCalories,
  getHighestUnitsPerDay,
  getUnitsAsDrinks,
  getDrinkValues,
  getDrinkerType
} from "@dcc/score/weekly";
import { getTotalWeeklyDrinkCount } from "../getterRules/totalWeeklyDrinks";
import { IScoreGetters } from "./types";
import { GetterNames } from "./names";
import { DrinkFrequency } from "@dcc/types/drinkFrequency";

export const getters: GetterTree<ScoreState, IRootState> = {
  [GetterNames.TOTALWEEKLYDRINKS](
    state: ScoreState,
    getters: IScoreGetters,
    rootState: IRootState,
    rootGetters: IRootGetters
  ): number {
    const drinkFrequency = rootGetters["drinking/drinkFrequency"];
    const numberOfMonthlyDrinkingDays =
      rootGetters["drinking/monthlyDrinkingDays"];
    const drinksByDay = rootGetters["drinking/actualDrinkingDays"];
    return getTotalWeeklyDrinkCount({
      drinkFrequency,
      drinksByDay,
      numberOfMonthlyDrinkingDays
    });
  },

  [GetterNames.WEEKLYUNITSANDCALORIES](
    state: ScoreState,
    getters: IScoreGetters,
    rootState: IRootState,
    rootGetters: IRootGetters
  ): UnitAndCalories {
    const unitsAndCaloriesPerDay =
      getters[GetterNames.CALORIESANDUNITSFOREACHDAY];
    const drinkFrequency = rootGetters["drinking/drinkFrequency"];
    const monthlyDrinkingDays = rootGetters["drinking/monthlyDrinkingDays"];

    return drinkFrequency
      ? getWeeklyUnitsAndCalories({
          unitsAndCaloriesPerDay,
          drinkFrequency,
          monthlyDrinkingDays
        })
      : emptyUnitAndCalories;
  },

  [GetterNames.ORIGINALWEEKLYUNITSANDCALORIES](
    state: ScoreState,
    getters: IScoreGetters,
    rootState: IRootState,
    rootGetters: IRootGetters
  ): UnitAndCalories {
    const unitsAndCaloriesPerDay =
      getters[GetterNames.ORIGINALCALORIESANDUNITSFOREACHDAY];
    const drinkFrequency = rootGetters["drinking/drinkFrequency"];
    const monthlyDrinkingDays = rootGetters["drinking/monthlyDrinkingDays"];

    return drinkFrequency
      ? getWeeklyUnitsAndCalories({
          unitsAndCaloriesPerDay,
          drinkFrequency,
          monthlyDrinkingDays
        })
      : emptyUnitAndCalories;
  },

  [GetterNames.WEEKLYUNITSASDRINKS](
    state: ScoreState,
    getters: IScoreGetters,
    rootState: IRootState,
    rootGetters: IRootGetters
  ): DrinkingDay {
    const drinkFrequency = rootGetters["drinking/drinkFrequency"];

    if (drinkFrequency && drinkFrequency === DrinkFrequency.Weekly) {
      const weeklyUnitsAndCalories =
        getters[GetterNames.WEEKLYUNITSANDCALORIES];
      return getUnitsAsDrinks(weeklyUnitsAndCalories.units);
    }
    return initialDrinkingDay;
  },

  [GetterNames.WEEKLYDRINKS](
    state: ScoreState,
    getters: IScoreGetters,
    rootState: IRootState,
    rootGetters: IRootGetters
  ): DrinkingDay {
    const drinkFrequency = rootGetters["drinking/drinkFrequency"];

    if (drinkFrequency && drinkFrequency === DrinkFrequency.Weekly) {
      const drinksByDay = rootGetters["drinking/actualDrinkingDays"];
      return getDrinkValues({
        drinksByDay
      });
    }
    return initialDrinkingDay;
  },
  [GetterNames.DRINKERTYPE](
    state: ScoreState,
    getters: IScoreGetters,
    rootState: IRootState,
    rootGetters: IRootGetters
  ): DrinkerType {
    const drinkFrequency = rootGetters["drinking/drinkFrequency"];

    if (drinkFrequency) {
      const drinksByDay = rootGetters["drinking/actualDrinkingDays"];
      return getDrinkerType({
        drinkFrequency,
        drinksByDay
      });
    } else {
      return initialDrinkerType;
    }
  },

  [GetterNames.HIGHESTUNITSPERDAY](
    state: ScoreState,
    getters: IScoreGetters,
    rootState: IRootState,
    rootGetters: IRootGetters
  ): number | undefined {
    const unitsAndCaloriesPerDay =
      getters[GetterNames.CALORIESANDUNITSFOREACHDAY];
    return getHighestUnitsPerDay(unitsAndCaloriesPerDay);
  }
};
